import { RootState } from 'data';
import { Task } from 'data/tasks';

export interface DerivedHomeResponse {
  myTasks: Array<Task>;
}

export const selectHomeItems = (state: RootState): DerivedHomeResponse => {
  const { home, tasks } = state;
  const { items } = home;

  return {
    myTasks: (items.myTasks ?? [])
      .map((t) => {
        return tasks.items[t];
      })
      .filter(Boolean) as Task[],
  };
};

export const selectMyCompanyTasks = ({ home, tasks }: RootState): Task[] => {
  return (home.items.myCompanyTasks ?? [])
    .map((t) => {
      return tasks.items[t];
    })
    .filter(Boolean) as Task[];
};
